import React from 'react';
import { action, observable } from 'mobx';
import { observer, Provider } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import RowContext from './context';
import './style.scss';

/**
 * Внутренний компонент, не для использования разработчиком.
 * Принимает пропы от <Table>:
 * @prop {object} record - объект записи.
 * @prop {number} row - номер строки.
 */

@withRouter @observer
export default class TableRow extends React.Component {

	gotoRecord = record => {
		const path = this.props.path ? this.props.path : record.MODEL ? record.MODEL.INFO.plural : null;
		if (path) {
			const rootPath = this.props.rootPath === '/' ? '' : this.props.rootPath;
			const goTo = `${rootPath}/${path}/${record.id}`;
			this.props.history.push(goTo.toLowerCase());
		}
	};

	onChange = (property, value) => {
		this.props.record[property] = value;
	};

	save = () => {
		this.props.record.save();
	};

	onRowClick = (record, row) => {
		if (this.props.onRowClick) {
			this.props.onRowClick(record, row);
		}
		else {
			this.gotoRecord(record);
		}
	};

	render() {
		const { children, debug, record, row, hilighted, clickable, rowClassName } = this.props;

		const rowData = {
			record,
			row,
			debug,
			clickable,
			save: this.save,
			onChange: this.onChange,
		};

		let column = 0;

		const _children = React.Children.map(children, child => {
			return child ? React.cloneElement(child, { column: column ++ }) : null;
		});

		let classes = [];
		if (rowClassName) {
			const rowClass = rowClassName(record, row);
			if (rowClass) classes.push(rowClass);
		}
		if (hilighted) classes.push('hilighted');
		const className = classes.length > 0 ? classes.join(' ') : undefined;

		return <tr onClick={() => this.onRowClick(record, row)} className={className}>
			<RowContext.Provider value={rowData}>
				{_children}
			</RowContext.Provider>
		</tr>;
	}
}
